/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * CyrenCare API
 * CyrenCare NestJS REST API for healthcare survey platform
 * OpenAPI spec version: 2.0
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery
} from '@tanstack/react-query'
import type {
  InfiniteData,
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import type {
  BulkAssignDto,
  BulkAssignResponseDto,
  BulkAssignToMeDto,
  CreatePatientVisitDto,
  GenerateDescriptiveReportDto,
  GenerateDescriptiveReportResponseDto,
  MyVisitDto,
  PatientVisitControllerFindByOrganizationParams,
  PatientVisitControllerSearchParams,
  PatientVisitListResponseDto,
  PatientVisitResponseDto,
  SuggestSymptomsDto,
  SuggestSymptomsResponseDto,
  UpdatePatientVisitDto
} from '.././types'
import { customInstance } from '../../custom-instance';
import type { ErrorType } from '../../custom-instance';


type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


/**
 * @summary Create a new patient visit
 */
export const patientVisitControllerCreate = (
    createPatientVisitDto: CreatePatientVisitDto,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<PatientVisitResponseDto>(
      {url: `/patient-visits`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createPatientVisitDto
    },
      options);
    }
  


export const getPatientVisitControllerCreateMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientVisitControllerCreate>>, TError,{data: CreatePatientVisitDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof patientVisitControllerCreate>>, TError,{data: CreatePatientVisitDto}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patientVisitControllerCreate>>, {data: CreatePatientVisitDto}> = (props) => {
          const {data} = props ?? {};

          return  patientVisitControllerCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatientVisitControllerCreateMutationResult = NonNullable<Awaited<ReturnType<typeof patientVisitControllerCreate>>>
    export type PatientVisitControllerCreateMutationBody = CreatePatientVisitDto
    export type PatientVisitControllerCreateMutationError = ErrorType<void>

    /**
 * @summary Create a new patient visit
 */
export const usePatientVisitControllerCreate = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientVisitControllerCreate>>, TError,{data: CreatePatientVisitDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof patientVisitControllerCreate>>,
        TError,
        {data: CreatePatientVisitDto},
        TContext
      > => {

      const mutationOptions = getPatientVisitControllerCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Get all patient visits
 */
export const patientVisitControllerFindAll = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<PatientVisitResponseDto[]>(
      {url: `/patient-visits`, method: 'GET', signal
    },
      options);
    }
  

export const getPatientVisitControllerFindAllQueryKey = () => {
    return [`/patient-visits`] as const;
    }

    
export const getPatientVisitControllerFindAllInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof patientVisitControllerFindAll>>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof patientVisitControllerFindAll>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPatientVisitControllerFindAllQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof patientVisitControllerFindAll>>> = ({ signal }) => patientVisitControllerFindAll(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof patientVisitControllerFindAll>>, TError, TData> & { queryKey: QueryKey }
}

export type PatientVisitControllerFindAllInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof patientVisitControllerFindAll>>>
export type PatientVisitControllerFindAllInfiniteQueryError = ErrorType<unknown>

/**
 * @summary Get all patient visits
 */
export const usePatientVisitControllerFindAllInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof patientVisitControllerFindAll>>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof patientVisitControllerFindAll>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getPatientVisitControllerFindAllInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getPatientVisitControllerFindAllQueryOptions = <TData = Awaited<ReturnType<typeof patientVisitControllerFindAll>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientVisitControllerFindAll>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPatientVisitControllerFindAllQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof patientVisitControllerFindAll>>> = ({ signal }) => patientVisitControllerFindAll(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof patientVisitControllerFindAll>>, TError, TData> & { queryKey: QueryKey }
}

export type PatientVisitControllerFindAllQueryResult = NonNullable<Awaited<ReturnType<typeof patientVisitControllerFindAll>>>
export type PatientVisitControllerFindAllQueryError = ErrorType<unknown>

/**
 * @summary Get all patient visits
 */
export const usePatientVisitControllerFindAll = <TData = Awaited<ReturnType<typeof patientVisitControllerFindAll>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientVisitControllerFindAll>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getPatientVisitControllerFindAllQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Search patient visits by criteria (e.g., UUID, AppointmentID)
 */
export const patientVisitControllerSearch = (
    params?: PatientVisitControllerSearchParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<PatientVisitResponseDto[]>(
      {url: `/patient-visits/search`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getPatientVisitControllerSearchQueryKey = (params?: PatientVisitControllerSearchParams,) => {
    return [`/patient-visits/search`, ...(params ? [params]: [])] as const;
    }

    
export const getPatientVisitControllerSearchInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof patientVisitControllerSearch>>>, TError = ErrorType<unknown>>(params?: PatientVisitControllerSearchParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof patientVisitControllerSearch>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPatientVisitControllerSearchQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof patientVisitControllerSearch>>> = ({ signal }) => patientVisitControllerSearch(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof patientVisitControllerSearch>>, TError, TData> & { queryKey: QueryKey }
}

export type PatientVisitControllerSearchInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof patientVisitControllerSearch>>>
export type PatientVisitControllerSearchInfiniteQueryError = ErrorType<unknown>

/**
 * @summary Search patient visits by criteria (e.g., UUID, AppointmentID)
 */
export const usePatientVisitControllerSearchInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof patientVisitControllerSearch>>>, TError = ErrorType<unknown>>(
 params?: PatientVisitControllerSearchParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof patientVisitControllerSearch>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getPatientVisitControllerSearchInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getPatientVisitControllerSearchQueryOptions = <TData = Awaited<ReturnType<typeof patientVisitControllerSearch>>, TError = ErrorType<unknown>>(params?: PatientVisitControllerSearchParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientVisitControllerSearch>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPatientVisitControllerSearchQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof patientVisitControllerSearch>>> = ({ signal }) => patientVisitControllerSearch(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof patientVisitControllerSearch>>, TError, TData> & { queryKey: QueryKey }
}

export type PatientVisitControllerSearchQueryResult = NonNullable<Awaited<ReturnType<typeof patientVisitControllerSearch>>>
export type PatientVisitControllerSearchQueryError = ErrorType<unknown>

/**
 * @summary Search patient visits by criteria (e.g., UUID, AppointmentID)
 */
export const usePatientVisitControllerSearch = <TData = Awaited<ReturnType<typeof patientVisitControllerSearch>>, TError = ErrorType<unknown>>(
 params?: PatientVisitControllerSearchParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientVisitControllerSearch>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getPatientVisitControllerSearchQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Get a patient visit by ID
 */
export const patientVisitControllerFindOne = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<PatientVisitResponseDto>(
      {url: `/patient-visits/${id}`, method: 'GET', signal
    },
      options);
    }
  

export const getPatientVisitControllerFindOneQueryKey = (id: number,) => {
    return [`/patient-visits/${id}`] as const;
    }

    
export const getPatientVisitControllerFindOneInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof patientVisitControllerFindOne>>>, TError = ErrorType<void>>(id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof patientVisitControllerFindOne>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPatientVisitControllerFindOneQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof patientVisitControllerFindOne>>> = ({ signal }) => patientVisitControllerFindOne(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof patientVisitControllerFindOne>>, TError, TData> & { queryKey: QueryKey }
}

export type PatientVisitControllerFindOneInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof patientVisitControllerFindOne>>>
export type PatientVisitControllerFindOneInfiniteQueryError = ErrorType<void>

/**
 * @summary Get a patient visit by ID
 */
export const usePatientVisitControllerFindOneInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof patientVisitControllerFindOne>>>, TError = ErrorType<void>>(
 id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof patientVisitControllerFindOne>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getPatientVisitControllerFindOneInfiniteQueryOptions(id,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getPatientVisitControllerFindOneQueryOptions = <TData = Awaited<ReturnType<typeof patientVisitControllerFindOne>>, TError = ErrorType<void>>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientVisitControllerFindOne>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPatientVisitControllerFindOneQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof patientVisitControllerFindOne>>> = ({ signal }) => patientVisitControllerFindOne(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof patientVisitControllerFindOne>>, TError, TData> & { queryKey: QueryKey }
}

export type PatientVisitControllerFindOneQueryResult = NonNullable<Awaited<ReturnType<typeof patientVisitControllerFindOne>>>
export type PatientVisitControllerFindOneQueryError = ErrorType<void>

/**
 * @summary Get a patient visit by ID
 */
export const usePatientVisitControllerFindOne = <TData = Awaited<ReturnType<typeof patientVisitControllerFindOne>>, TError = ErrorType<void>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientVisitControllerFindOne>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getPatientVisitControllerFindOneQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Update a patient visit
 */
export const patientVisitControllerUpdate = (
    id: number,
    updatePatientVisitDto: UpdatePatientVisitDto,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<PatientVisitResponseDto>(
      {url: `/patient-visits/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updatePatientVisitDto
    },
      options);
    }
  


export const getPatientVisitControllerUpdateMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientVisitControllerUpdate>>, TError,{id: number;data: UpdatePatientVisitDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof patientVisitControllerUpdate>>, TError,{id: number;data: UpdatePatientVisitDto}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patientVisitControllerUpdate>>, {id: number;data: UpdatePatientVisitDto}> = (props) => {
          const {id,data} = props ?? {};

          return  patientVisitControllerUpdate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatientVisitControllerUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof patientVisitControllerUpdate>>>
    export type PatientVisitControllerUpdateMutationBody = UpdatePatientVisitDto
    export type PatientVisitControllerUpdateMutationError = ErrorType<void>

    /**
 * @summary Update a patient visit
 */
export const usePatientVisitControllerUpdate = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientVisitControllerUpdate>>, TError,{id: number;data: UpdatePatientVisitDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof patientVisitControllerUpdate>>,
        TError,
        {id: number;data: UpdatePatientVisitDto},
        TContext
      > => {

      const mutationOptions = getPatientVisitControllerUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Delete a patient visit
 */
export const patientVisitControllerRemove = (
    id: number,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/patient-visits/${id}`, method: 'DELETE'
    },
      options);
    }
  


export const getPatientVisitControllerRemoveMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientVisitControllerRemove>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof patientVisitControllerRemove>>, TError,{id: number}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patientVisitControllerRemove>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  patientVisitControllerRemove(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatientVisitControllerRemoveMutationResult = NonNullable<Awaited<ReturnType<typeof patientVisitControllerRemove>>>
    
    export type PatientVisitControllerRemoveMutationError = ErrorType<void>

    /**
 * @summary Delete a patient visit
 */
export const usePatientVisitControllerRemove = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientVisitControllerRemove>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof patientVisitControllerRemove>>,
        TError,
        {id: number},
        TContext
      > => {

      const mutationOptions = getPatientVisitControllerRemoveMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Get patient visits by organization
 */
export const patientVisitControllerFindByOrganization = (
    orgId: number,
    params?: PatientVisitControllerFindByOrganizationParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<PatientVisitListResponseDto>(
      {url: `/patient-visits/organization/${orgId}`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getPatientVisitControllerFindByOrganizationQueryKey = (orgId: number,
    params?: PatientVisitControllerFindByOrganizationParams,) => {
    return [`/patient-visits/organization/${orgId}`, ...(params ? [params]: [])] as const;
    }

    
export const getPatientVisitControllerFindByOrganizationInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof patientVisitControllerFindByOrganization>>>, TError = ErrorType<unknown>>(orgId: number,
    params?: PatientVisitControllerFindByOrganizationParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof patientVisitControllerFindByOrganization>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPatientVisitControllerFindByOrganizationQueryKey(orgId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof patientVisitControllerFindByOrganization>>> = ({ signal }) => patientVisitControllerFindByOrganization(orgId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(orgId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof patientVisitControllerFindByOrganization>>, TError, TData> & { queryKey: QueryKey }
}

export type PatientVisitControllerFindByOrganizationInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof patientVisitControllerFindByOrganization>>>
export type PatientVisitControllerFindByOrganizationInfiniteQueryError = ErrorType<unknown>

/**
 * @summary Get patient visits by organization
 */
export const usePatientVisitControllerFindByOrganizationInfinite = <TData = InfiniteData<Awaited<ReturnType<typeof patientVisitControllerFindByOrganization>>>, TError = ErrorType<unknown>>(
 orgId: number,
    params?: PatientVisitControllerFindByOrganizationParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof patientVisitControllerFindByOrganization>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getPatientVisitControllerFindByOrganizationInfiniteQueryOptions(orgId,params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getPatientVisitControllerFindByOrganizationQueryOptions = <TData = Awaited<ReturnType<typeof patientVisitControllerFindByOrganization>>, TError = ErrorType<unknown>>(orgId: number,
    params?: PatientVisitControllerFindByOrganizationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientVisitControllerFindByOrganization>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPatientVisitControllerFindByOrganizationQueryKey(orgId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof patientVisitControllerFindByOrganization>>> = ({ signal }) => patientVisitControllerFindByOrganization(orgId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(orgId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof patientVisitControllerFindByOrganization>>, TError, TData> & { queryKey: QueryKey }
}

export type PatientVisitControllerFindByOrganizationQueryResult = NonNullable<Awaited<ReturnType<typeof patientVisitControllerFindByOrganization>>>
export type PatientVisitControllerFindByOrganizationQueryError = ErrorType<unknown>

/**
 * @summary Get patient visits by organization
 */
export const usePatientVisitControllerFindByOrganization = <TData = Awaited<ReturnType<typeof patientVisitControllerFindByOrganization>>, TError = ErrorType<unknown>>(
 orgId: number,
    params?: PatientVisitControllerFindByOrganizationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientVisitControllerFindByOrganization>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getPatientVisitControllerFindByOrganizationQueryOptions(orgId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Patient My Visit Logic
 */
export const patientVisitControllerMyVisit = (
    myVisitDto: MyVisitDto,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/patient-visits/my-visit`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: myVisitDto
    },
      options);
    }
  


export const getPatientVisitControllerMyVisitMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientVisitControllerMyVisit>>, TError,{data: MyVisitDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof patientVisitControllerMyVisit>>, TError,{data: MyVisitDto}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patientVisitControllerMyVisit>>, {data: MyVisitDto}> = (props) => {
          const {data} = props ?? {};

          return  patientVisitControllerMyVisit(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatientVisitControllerMyVisitMutationResult = NonNullable<Awaited<ReturnType<typeof patientVisitControllerMyVisit>>>
    export type PatientVisitControllerMyVisitMutationBody = MyVisitDto
    export type PatientVisitControllerMyVisitMutationError = ErrorType<unknown>

    /**
 * @summary Patient My Visit Logic
 */
export const usePatientVisitControllerMyVisit = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientVisitControllerMyVisit>>, TError,{data: MyVisitDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof patientVisitControllerMyVisit>>,
        TError,
        {data: MyVisitDto},
        TContext
      > => {

      const mutationOptions = getPatientVisitControllerMyVisitMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Suggest symptoms using LLM
 */
export const patientVisitControllerSuggestSymptoms = (
    suggestSymptomsDto: SuggestSymptomsDto,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<SuggestSymptomsResponseDto>(
      {url: `/patient-visits/suggest-symptoms`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: suggestSymptomsDto
    },
      options);
    }
  


export const getPatientVisitControllerSuggestSymptomsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientVisitControllerSuggestSymptoms>>, TError,{data: SuggestSymptomsDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof patientVisitControllerSuggestSymptoms>>, TError,{data: SuggestSymptomsDto}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patientVisitControllerSuggestSymptoms>>, {data: SuggestSymptomsDto}> = (props) => {
          const {data} = props ?? {};

          return  patientVisitControllerSuggestSymptoms(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatientVisitControllerSuggestSymptomsMutationResult = NonNullable<Awaited<ReturnType<typeof patientVisitControllerSuggestSymptoms>>>
    export type PatientVisitControllerSuggestSymptomsMutationBody = SuggestSymptomsDto
    export type PatientVisitControllerSuggestSymptomsMutationError = ErrorType<unknown>

    /**
 * @summary Suggest symptoms using LLM
 */
export const usePatientVisitControllerSuggestSymptoms = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientVisitControllerSuggestSymptoms>>, TError,{data: SuggestSymptomsDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof patientVisitControllerSuggestSymptoms>>,
        TError,
        {data: SuggestSymptomsDto},
        TContext
      > => {

      const mutationOptions = getPatientVisitControllerSuggestSymptomsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Generate descriptive report using LLM
 */
export const patientVisitControllerGenerateDescriptiveReport = (
    generateDescriptiveReportDto: GenerateDescriptiveReportDto,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<GenerateDescriptiveReportResponseDto>(
      {url: `/patient-visits/generate-descriptive-report`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: generateDescriptiveReportDto
    },
      options);
    }
  


export const getPatientVisitControllerGenerateDescriptiveReportMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientVisitControllerGenerateDescriptiveReport>>, TError,{data: GenerateDescriptiveReportDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof patientVisitControllerGenerateDescriptiveReport>>, TError,{data: GenerateDescriptiveReportDto}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patientVisitControllerGenerateDescriptiveReport>>, {data: GenerateDescriptiveReportDto}> = (props) => {
          const {data} = props ?? {};

          return  patientVisitControllerGenerateDescriptiveReport(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatientVisitControllerGenerateDescriptiveReportMutationResult = NonNullable<Awaited<ReturnType<typeof patientVisitControllerGenerateDescriptiveReport>>>
    export type PatientVisitControllerGenerateDescriptiveReportMutationBody = GenerateDescriptiveReportDto
    export type PatientVisitControllerGenerateDescriptiveReportMutationError = ErrorType<unknown>

    /**
 * @summary Generate descriptive report using LLM
 */
export const usePatientVisitControllerGenerateDescriptiveReport = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientVisitControllerGenerateDescriptiveReport>>, TError,{data: GenerateDescriptiveReportDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof patientVisitControllerGenerateDescriptiveReport>>,
        TError,
        {data: GenerateDescriptiveReportDto},
        TContext
      > => {

      const mutationOptions = getPatientVisitControllerGenerateDescriptiveReportMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Bulk assign/unassign patient visits
 */
export const patientVisitControllerBulkAssign = (
    bulkAssignDto: BulkAssignDto,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<BulkAssignResponseDto>(
      {url: `/patient-visits/bulk-assign`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: bulkAssignDto
    },
      options);
    }
  


export const getPatientVisitControllerBulkAssignMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientVisitControllerBulkAssign>>, TError,{data: BulkAssignDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof patientVisitControllerBulkAssign>>, TError,{data: BulkAssignDto}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patientVisitControllerBulkAssign>>, {data: BulkAssignDto}> = (props) => {
          const {data} = props ?? {};

          return  patientVisitControllerBulkAssign(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatientVisitControllerBulkAssignMutationResult = NonNullable<Awaited<ReturnType<typeof patientVisitControllerBulkAssign>>>
    export type PatientVisitControllerBulkAssignMutationBody = BulkAssignDto
    export type PatientVisitControllerBulkAssignMutationError = ErrorType<unknown>

    /**
 * @summary Bulk assign/unassign patient visits
 */
export const usePatientVisitControllerBulkAssign = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientVisitControllerBulkAssign>>, TError,{data: BulkAssignDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof patientVisitControllerBulkAssign>>,
        TError,
        {data: BulkAssignDto},
        TContext
      > => {

      const mutationOptions = getPatientVisitControllerBulkAssignMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Bulk assign patient visits to current user
 */
export const patientVisitControllerBulkAssignToMe = (
    bulkAssignToMeDto: BulkAssignToMeDto,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<BulkAssignResponseDto>(
      {url: `/patient-visits/bulk-assign-to-me`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: bulkAssignToMeDto
    },
      options);
    }
  


export const getPatientVisitControllerBulkAssignToMeMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientVisitControllerBulkAssignToMe>>, TError,{data: BulkAssignToMeDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof patientVisitControllerBulkAssignToMe>>, TError,{data: BulkAssignToMeDto}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patientVisitControllerBulkAssignToMe>>, {data: BulkAssignToMeDto}> = (props) => {
          const {data} = props ?? {};

          return  patientVisitControllerBulkAssignToMe(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatientVisitControllerBulkAssignToMeMutationResult = NonNullable<Awaited<ReturnType<typeof patientVisitControllerBulkAssignToMe>>>
    export type PatientVisitControllerBulkAssignToMeMutationBody = BulkAssignToMeDto
    export type PatientVisitControllerBulkAssignToMeMutationError = ErrorType<unknown>

    /**
 * @summary Bulk assign patient visits to current user
 */
export const usePatientVisitControllerBulkAssignToMe = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientVisitControllerBulkAssignToMe>>, TError,{data: BulkAssignToMeDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof patientVisitControllerBulkAssignToMe>>,
        TError,
        {data: BulkAssignToMeDto},
        TContext
      > => {

      const mutationOptions = getPatientVisitControllerBulkAssignToMeMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Assign a patient visit to current user
 */
export const patientVisitControllerAssignToMe = (
    id: number,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<PatientVisitResponseDto>(
      {url: `/patient-visits/${id}/assign-to-me`, method: 'POST'
    },
      options);
    }
  


export const getPatientVisitControllerAssignToMeMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientVisitControllerAssignToMe>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof patientVisitControllerAssignToMe>>, TError,{id: number}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patientVisitControllerAssignToMe>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  patientVisitControllerAssignToMe(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatientVisitControllerAssignToMeMutationResult = NonNullable<Awaited<ReturnType<typeof patientVisitControllerAssignToMe>>>
    
    export type PatientVisitControllerAssignToMeMutationError = ErrorType<unknown>

    /**
 * @summary Assign a patient visit to current user
 */
export const usePatientVisitControllerAssignToMe = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientVisitControllerAssignToMe>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof patientVisitControllerAssignToMe>>,
        TError,
        {id: number},
        TContext
      > => {

      const mutationOptions = getPatientVisitControllerAssignToMeMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Unassign a patient visit
 */
export const patientVisitControllerUnassign = (
    id: number,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<PatientVisitResponseDto>(
      {url: `/patient-visits/${id}/unassign`, method: 'POST'
    },
      options);
    }
  


export const getPatientVisitControllerUnassignMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientVisitControllerUnassign>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof patientVisitControllerUnassign>>, TError,{id: number}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patientVisitControllerUnassign>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  patientVisitControllerUnassign(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatientVisitControllerUnassignMutationResult = NonNullable<Awaited<ReturnType<typeof patientVisitControllerUnassign>>>
    
    export type PatientVisitControllerUnassignMutationError = ErrorType<unknown>

    /**
 * @summary Unassign a patient visit
 */
export const usePatientVisitControllerUnassign = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientVisitControllerUnassign>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof patientVisitControllerUnassign>>,
        TError,
        {id: number},
        TContext
      > => {

      const mutationOptions = getPatientVisitControllerUnassignMutationOptions(options);

      return useMutation(mutationOptions);
    }
    